module.exports = __webpack_public_path__ + "gold.9dfe87b5.png";